type Translate = (key: string, options?: { defaultValue?: string }) => string;

export const EMPLOYMENT_CONTRACT_TYPES = [
  { value: "full_time_indefinite", labelKey: "contractTypes.fullTimeIndefinite" },
  { value: "full_time_fixed_term", labelKey: "contractTypes.fullTimeFixedTerm" },
  { value: "part_time_indefinite", labelKey: "contractTypes.partTimeIndefinite" },
  { value: "part_time_fixed_term", labelKey: "contractTypes.partTimeFixedTerm" },
  { value: "seasonal_work", labelKey: "contractTypes.seasonalWork" },
  { value: "service_contract", labelKey: "contractTypes.serviceContract" },
  { value: "copyright_contract", labelKey: "contractTypes.copyrightContract" },
  { value: "temporary_occasional", labelKey: "contractTypes.temporaryOccasional" },
] as const;

export type EmploymentContractTypeValue = (typeof EMPLOYMENT_CONTRACT_TYPES)[number]["value"];

export const DEFAULT_EMPLOYMENT_CONTRACT_TYPE: EmploymentContractTypeValue = "full_time_indefinite";

const contractTypeLabelKeys = new Map<string, string>([
  ...EMPLOYMENT_CONTRACT_TYPES.map((option) => [option.value, option.labelKey] as const),
  ["Full-time", "contractTypes.fullTimeIndefinite"],
  ["Part-time", "contractTypes.partTimeIndefinite"],
  ["Contract", "contractTypes.serviceContract"],
  ["Intern", "contractTypes.legacyIntern"],
]);

export function getContractTypeLabel(value: string | null | undefined, t: Translate): string {
  if (!value) return "";
  const key = contractTypeLabelKeys.get(value);
  return key ? t(key, { defaultValue: value }) : value;
}

export function isFixedTermContractType(value: string | null | undefined): boolean {
  return value === "full_time_fixed_term" || value === "part_time_fixed_term";
}

export function isFullTimeContractType(value: string | null | undefined): boolean {
  return value === "full_time_indefinite" || value === "full_time_fixed_term" || value === "Full-time";
}

export function isPartTimeContractType(value: string | null | undefined): boolean {
  return value === "part_time_indefinite" || value === "part_time_fixed_term" || value === "Part-time";
}

export function isContractorContractType(value: string | null | undefined): boolean {
  return value === "service_contract" || value === "Contract";
}
export function calculatePartTimeWeeklyHours(
  hoursPerDay: number | string | null | undefined,
  includesSaturday: boolean | null | undefined,
): number | null {
  if (hoursPerDay === null || hoursPerDay === undefined || hoursPerDay === "") return null;
  const dailyHours = Number(hoursPerDay);
  if (!Number.isFinite(dailyHours)) return null;
  const daysPerWeek = includesSaturday ? 6 : 5;
  return Math.round(dailyHours * daysPerWeek * 100) / 100;
}
